import script from "./AddNewBar.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNewBar.vue?vue&type=script&setup=true&lang=js"

import "./AddNewBar.vue?vue&type=style&index=0&id=0c208c79&lang=css"

const __exports__ = script;

export default __exports__